import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { Iframe, NavLink, Template, UIFrame } from '..';

const Start = ({ content, scenarios, setScenario }) => {
  const navigation = (
    <>
      {scenarios.map((scenario) => (
        <NavLink key={scenario.key} label={{ intl: `${scenario.key}.title` }} handler={() => setScenario(scenario)} />
      ))}
    </>
  );

  const { start } = content;
  const { image, video } = start;

  return (
    <Template navigation={navigation}>
      <UIFrame>
        {video && <Iframe src={video} />}
        {image && <img src={image} css={styles.screen} alt="" />}
      </UIFrame>
    </Template>
  );
};

const styles = {
  launch: css`
    padding-left: 0;
    min-width: 100px;

    &:hover {
      background-color: inherit;
    }
  `,
  screen: css`
    display: block;
    width: 100%;
    height: auto;
  `,
};

Start.propTypes = {
  content: PropTypes.object.isRequired,
  scenarios: PropTypes.array.isRequired,
  setScenario: PropTypes.func.isRequired,
};

export default Start;
